<template>
  <module-page v-bind="pageParams" :loading="!!loadingProduct">
    <div class="my-decorated" v-show="!iframeError">
      <iframe v-if="url" ref="iframe" class="my-decorated__iframe" :src="url" />
      <div class="my-decorated__footer">
        <p>{{ message1 }}</p>
        <p>{{ message2 }}</p>
        <v-btn
          v-if="tourUrl.length > 0"
          class="my-decorated__footer-btn"
          @click="goToTour"
          >Tour do decorado</v-btn
        >
      </div>
    </div>
    <empty-state-card
      v-if="iframeError"
      :message="$t('responses.error')"
      icon="alert"
    ></empty-state-card>
  </module-page>
</template>

<script>
import { APP, IFRAME } from '../../utils/constants';
import ModulePage from '@/components/layout/Page';
import EmptyStateCard from '@/components/layout/EmptyStateCard.vue';
export default {
  name: 'myDecorated',
  components: {
    ModulePage,
    EmptyStateCard,
  },
  computed: {
    url(){
      return this.$store.getters[IFRAME.GET_DECORATED_PAGE_URL];
    }
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].myDecorated,
      url: '',
      tourUrl: '',
      message1:
        'Plantas ilustrativas com sugestões de decoração. Os imóveis e equipamentos têm dimensões comerciais e não fazem parte do contrato.',
      message2:
        'As medidas são internas e de face a face das paredes, sujeitas a pequenas variações de acordo com as exigências técnicas e/ou acabamentos. O imóvel será entregue conforme o manual do descritivo.',
      iframeError: false,
      getTourUrlError: false,
      loadingProduct: null,
    };
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.my-decorated {
  box-shadow: var(--box-shadow);
  width: 80%;
  padding: 25px 15px;
  margin: 25px 0;

  @include breakpoint(mobile) {
    width: 100%;
    padding: 20px;
  }

  &__footer {
    font-size: 11px;
    font-weight: 500;

    p {
      margin: 0;
    }

    &-btn {
      margin: 10px 0;
      background-color: var(--brand-color) !important;
      color: #fff !important;
    }
  }

  &__iframe {
    width: 100%;
    height: 100%;
    min-height: 600px;
    border: none;

    @include breakpoint(mobile) {
      min-height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/MyDecorated.vue